import React from 'react';
import uuid from '../../../../../core/components/UniqueHash';
import { useModal } from '../../../../../../../hooks/Modal';

import api from '../../../../../../../services/api';
import { useToast } from '../../../../../../../hooks/Toast';
import { useSearch } from '../../../../../../../hooks/Search';
import { FaEdit, FaUpload } from 'react-icons/fa';
import { Form } from '@unform/web';
import UploadImage from '../../../../../core/components/Forms/UploadImage';
import Button from '../../../../../core/components/Forms/Button';



export default function UpdateModule(): JSX.Element {
  const { reloadSearchAll } = useSearch();
  const { addModal, removeModal } = useModal();
  const { addToast } = useToast();
  const key = uuid();

  const uploadContacts = async (data) => {

    const formData = new FormData();
    formData.append('file', data.file);







    await api.post(`/upload-cientific-confirmations`, formData);



  }

  const handleUpdate = async (): Promise<void> => {


    const content = (
      <Form onSubmit={uploadContacts}>

        <UploadImage name="file" placeholder='Excel com confirmações' />
        <Button>Enviar</Button>
      </Form>
    );
    if (content) {
      const keyModal = addModal({ title: 'Upload de contatos', content, key, theme: "whiteModal" });
    }
  };

  const moduleUpdate = (): JSX.Element => (
    <button className="lineIcon" title="Editar" type="button" onClick={() => handleUpdate()}>
      <FaUpload />
    </button>
  );

  return moduleUpdate();
}
